"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var carOptionsStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        optionsWrapper: {
            padding: '20px 0 0 0',
            fontFamily: typography.fontFamily,
        },
        option: {
            padding: '5px 0',
            '& span': {
                fontFamily: typography.fontFamily,
            },
        },
        optionsSectionTitle: {
            marginBottom: '10px',
            fontFamily: typography.fontFamily2,
        },
        optionsPrice: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            padding: '5px 0 30px 0',
        },
        optionsPriceLabel: {},
        optionsPriceValue: {},
    });
}, { name: 'Summary_CarOptions' });
exports.default = carOptionsStyles;
